// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__kBQZt","wrapper":"footer_wrapper__Hwbpq","text":"footer_text__yN-jc","mobileText":"footer_mobileText__OgdBw"};